import { togglePanel } from '@src/components/AppLayout/AppLayoutSlice';
import { getLayoutGroupById } from '@src/providers/AppLayoutContextProvider/utils/getLayoutGroupById';
import { useAppStateDispatch, useAppStateSelector } from '@src/providers/AppStateProvider';
import {
  ButtonVariants,
  FormControlSizes,
  IconName,
  MixpanelEvent,
  MixpanelEventProperty,
  useMixpanel,
} from '@talos/kyoko';
import { useCallback, useMemo } from 'react';
import { HeaderButton } from './HeaderButton';

export const WatchlistButton = () => {
  const mixpanel = useMixpanel();

  const currentLayout = useAppStateSelector(state => state.appLayout.currentLayout);
  const openPanels = useAppStateSelector(state => state.appLayout.openPanels);
  const dispatch = useAppStateDispatch();
  const watchlistIsVisible = openPanels.includes('watchlists');

  const toggleWatchlistVisible = useCallback(() => {
    mixpanel.track(MixpanelEvent.ToggleWatchlist, { [MixpanelEventProperty.Enabled]: !watchlistIsVisible });
    dispatch(togglePanel('watchlists'));
  }, [dispatch, mixpanel, watchlistIsVisible]);

  const showWatchlist = useMemo(
    () =>
      !currentLayout ||
      (currentLayout?.collapsablePanels.findIndex(panel => panel.groupId === 'watchlists') !== -1 &&
        getLayoutGroupById(currentLayout.dockViewLayout, 'watchlists')),
    [currentLayout]
  );

  return showWatchlist ? (
    <HeaderButton
      data-testid="watchlist-button"
      borderPlacement="right"
      onClick={toggleWatchlistVisible}
      size={FormControlSizes.Small}
      variant={watchlistIsVisible ? ButtonVariants.Priority : ButtonVariants.Default}
      startIcon={IconName.PresentationChartLine}
    >
      Watchlist
    </HeaderButton>
  ) : null;
};
